import React from 'react'
import { MedicineTable as MT } from '../../features/treatments/MedicineTable'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { useParams } from 'react-router-dom'
import { RouteProps } from '../../routes/AppRouter'

export function Medicines(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const { id } = useParams()

  setTitle(title)

  return <MT id={id} />
}
